<template>
    <div class="content">
        <div
            v-html="icon"
            class="icon"
        ></div>

        <div v-if="messages.length">
            <div class="title">Первый шаг сделан!</div>
            <div class="description ta-center">
                <p>Вы отметили стереотипы, которые так или иначе присутствуют в вашей жизни.</p>
                <p>Посмотрите на список ниже и ознакомьтесь с другой точкой зрения. Взляните на старые установки под другим углом</p>
            </div>
            <category-title></category-title>
            <messages-list></messages-list>
        </div>

        <div v-if="messages.length >= 2">
            <div class="description">
                <p>
                    Некоторые точки зрения могли показаться вам интересными, полезными или неожиданными.
                    Возвращайтесь на главную страницу и поработайте со стереотипами в других сферах
                </p>
            </div>
        </div>

        <div v-if="!messages.length">
            <div class="title">Вы не отметили ни одного стереотипа</div>
            <div class="description ta-center">
                <p>Возвращайтесь на главную и пробуйте поискать в другой сфере :-)</p>
            </div>
        </div>

        <div class="controls">
            <router-link
                to="/"
                v-slot="{ href, route, navigate }"
            >
                <app-button
                    :href="href"
                    @click.native="navigate"
                    type="default"
                    align="center"
                    class="button"
                >На главную</app-button>
            </router-link>
        </div>
    </div>
</template>

<script>
    import icons from '@/configs/icons.js';
    import AppButton from '@/components/AppButton.vue';
    import CategoryTitle from '@/components/CategoryTitle.vue';
    import MessagesList from '@/components/MessagesList.vue';

    export default {
        name: 'CategoryFinish',
        components: {
            MessagesList,
            AppButton,
            CategoryTitle
        },
        computed: {
            icon () {
                return icons.app.okHand;
            },
            messages () {
                return this.$store.getters.getMessagesByState('yes');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .icon {
        margin-top: 1em;
        text-align: center;
    }

    .title {
        font-size: 2em;
        text-align: center;
        margin: 1em 0;
    }

    .controls {
        margin-top: 2em;
    }
</style>